import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import ProblemSection from "@/components/ProblemSection";
import PointOfView from "@/components/PointOfView";
import FrameworkSection from "@/components/FrameworkSection";
import ServicesSection from "@/components/ServicesSection";
import WhatAxiomFinds from "@/components/WhatAxiomFinds";
import CaseStudies from "@/components/CaseStudies";
import SignalLibrary from "@/components/SignalLibrary";
import LeadMagnet from "@/components/LeadMagnet";
import AboutSection from "@/components/AboutSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 80);
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <ProblemSection />
        <PointOfView />
        <FrameworkSection />
        <ServicesSection />
        <WhatAxiomFinds />
        <CaseStudies />
        <SignalLibrary />
        <LeadMagnet />
        <AboutSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
